'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Kritinė klaida:', error);
  }, [error]);

  return (
    <html data-component-id="src/app/global-error.tsx:17:4" data-component-path="src/app/global-error.tsx" data-component-line="17" data-component-end-line="64" data-component-file="global-error.tsx" data-component-name="html" data-component-content="%7B%22elementName%22%3A%22html%22%7D" lang="lt">
      <body data-component-id="src/app/global-error.tsx:18:6" data-component-path="src/app/global-error.tsx" data-component-line="18" data-component-end-line="63" data-component-file="global-error.tsx" data-component-name="body" data-component-content="%7B%22elementName%22%3A%22body%22%7D" style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#0f172a' }}>
        <div data-component-id="src/app/global-error.tsx:19:8" data-component-path="src/app/global-error.tsx" data-component-line="19" data-component-end-line="62" data-component-file="global-error.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
          }}
        >
          <div data-component-id="src/app/global-error.tsx:28:10" data-component-path="src/app/global-error.tsx" data-component-line="28" data-component-end-line="61" data-component-file="global-error.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
            style={{
              maxWidth: 420,
              width: '100%',
              background: 'rgba(30,41,59,0.6)',
              border: '1px solid rgba(51,65,85,0.5)',
              borderRadius: 16,
              padding: 32,
              textAlign: 'center',
              color: '#e2e8f0',
            }}
          >
            <h2 data-component-id="src/app/global-error.tsx:40:12" data-component-path="src/app/global-error.tsx" data-component-line="40" data-component-end-line="42" data-component-file="global-error.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22textContent%22%3A%22Kritin%C4%97%20programos%20klaida%22%7D" style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
              Kritinė programos klaida
            </h2>
            <p data-component-id="src/app/global-error.tsx:43:12" data-component-path="src/app/global-error.tsx" data-component-line="43" data-component-end-line="45" data-component-file="global-error.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22textContent%22%3A%22Programa%20netik%C4%97tai%20nustojo%20veikti.%20Pabandykite%20perkrauti.%22%7D" style={{ color: '#94a3b8', fontSize: 14, marginBottom: 24 }}>
              Programa netikėtai nustojo veikti. Pabandykite perkrauti.
            </p>
            <button data-component-id="src/app/global-error.tsx:46:12" data-component-path="src/app/global-error.tsx" data-component-line="46" data-component-end-line="60" data-component-file="global-error.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22Perkrauti%22%7D"
              onClick={reset}
              style={{
                background: '#0ea5e9',
                color: '#fff',
                border: 'none',
                padding: '10px 16px',
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Perkrauti
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
